import { isSameDay, isAfter, isBefore, formatISO } from 'date-fns';
import toDate from 'date-fns-tz/toDate';

export const getDateViolations = ({ isEdit, policy, segment, startDate, minDate, toast }) => {
  const dateViolations = {
    BEFORE_MIN_DATE: isBefore(startDate, minDate) && !isSameDay(startDate, minDate),
    START_DATE_ALREADY_EXISTS:
      isEdit &&
      policy?.segments.find(
        (segmentFromList) =>
          segmentFromList.segmentId !== segment.segmentId &&
          isSameDay(toDate(segmentFromList.startDate), toDate(startDate))
      )
  };

  const foundViolation = Object.keys(dateViolations).find((violation) => dateViolations[violation]);

  if (foundViolation) {
    const dateViolationMessages = ({ startDateFormatted, endDateFormatted, minDateFormatted }) => {
      return {
        BEFORE_MIN_DATE: `Please choose a date later than or equal to ${minDateFormatted[1]}/${minDateFormatted[2]}/${minDateFormatted[0]}`,
        START_DATE_ALREADY_EXISTS: `Segment with start date ${startDateFormatted[1]}/${startDateFormatted[2]}/${startDateFormatted[0]} already exists.`
      };
    };

    toast.notify({
      type: 'error',
      message: dateViolationMessages({
        startDateFormatted: formatISO(startDate).split('T')[0].split('-'),
        endDateFormatted: policy.endDate.split('-'),
        minDateFormatted: formatISO(minDate).split('T')[0].split('-')
      })[foundViolation]
    });
    return true;
  }
  return false;
};
